import styles from "./styles/result_banner.module.scss";

export const ResultBanner = (data: { text: string; type: string }) => {
  const renderType = () => {
    switch (data.type) {
      case "success":
        return styles.success;
      case "warning":
        return styles.warning;
      case "failed":
        return styles.failed;
    }
  };

  return (
    <>
      <div className={`${styles.wrapper} ${renderType()}`}>
        <span className={styles.content}>{data.text}</span>
      </div>
    </>
  );
};
